import React from "react";

export default function HomePage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
      <h1 className="text-4xl font-bold mb-6">Welcome to H Evans Acres</h1>
      <a
        href="https://hevansacres.com/collections/craft-handmade"
        target="_blank"
        rel="noreferrer"
        className="px-6 py-3 bg-blue-500 text-white rounded hover:bg-blue-600 text-lg"
      >
        Visit Our Crafts Collection
      </a>
    </div>
  );
}
